exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul[data-v-ac7221dc] {\n  list-style-type: disc;\n  margin-left: 1.5em;\n}\n.subtitle[data-v-ac7221dc]{\n  font-size: 12px!important;\n}\n", ""]);

// exports
